import { QuestionCard, Header, Footer } from "./index";
import "./TestScreen.css";
import SectionTabs from "./SectionTabs";
import useAppHooks from "../../../../shared/hooks/useAppHooks";
import {
  saveAnswerRequest,
  submitExamRequest,
  updateQuestionStatus,
} from "../../../../redux/exam/examSlice";
import { useState } from "react";
import SubmitModal from "../../../../shared/components/SubmitModal/SubmitModal";
import images from "../../../../utilities/images/images";
import { markQuestionForReview } from "../../../../redux/exam/examSlice";
import { getQuestionStats } from "../utils/questionStats";
import { backGroundColorFromBackend } from "../../../../custom_utilities/custom_useful_functions";
import { ClipLoader } from "react-spinners";

const TestScreen = () => {
  const { selector, dispatch, history } = useAppHooks();
  const { questionsData, currentQuestionIndex, loading, submitResult } =
    selector((s) => s.examSlice);

  const stats = getQuestionStats(questionsData);

  const [activeQuestionId, setActiveQuestionId] = useState(null);
  const [isSubmitModalOpen, setSubmitModalOpen] = useState(false);

  // ✅ Track total time used
  const [totalTimeUsed, setTotalTimeUsed] = useState(0);

  const handleTimeUpdate = (usedTime) => {
    setTotalTimeUsed(usedTime);
  };

  // Save & Next
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleSaveAndNext = () => {
    const currentQuestion = questionsData[currentQuestionIndex];
    dispatch(saveAnswerRequest());
  };

  // Select question manually
  const handleSelectQuestion = (id) => {
    setActiveQuestionId(id);
  };

  // Modal handlers
  const handleOpenSubmitModal = () => setSubmitModalOpen(true);
  const handleCloseSubmitModal = () => setSubmitModalOpen(false);

  // ✅ Submit exam via API
  const handleSubmitExam = () => {
    const payload = {
      // paper_id: 14596,
      time: 50,
      // test_id: 76,
      // paper_type: 3,
    };
    dispatch(submitExamRequest(payload));
    setSubmitModalOpen(false);
    history.push("/analytics");
  };

  const onMarkReview = () => {
    const currentQuestion = questionsData[currentQuestionIndex];
    if (!currentQuestion) return;
    dispatch(
      updateQuestionStatus({ qid: currentQuestion.qid, markReview: true })
    );
  };
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "40px",
          width: "100%",
          height: "200px",
        }}
      >
        <ClipLoader size={40} color="#C61C26" />
      </div>
    );
  }

  return (
    <div className="exam-wrapper">
      <Header onSubmit={handleOpenSubmitModal} />

      <div className="exam-body">
        <div className={`exam-content ${isSidebarOpen ? "sidebar-open" : ""}`}>
          <div className="exam_content_container">
            {/* Pass sidebar state & toggle fn to SectionTabs */}
            <SectionTabs
              isSidebarOpen={isSidebarOpen}
              setIsSidebarOpen={setIsSidebarOpen}
              onSelectQuestion={handleSelectQuestion}
            />

            <QuestionCard questionId={activeQuestionId} />
            <Footer
              onSaveNext={handleSaveAndNext}
              onMarkReview={onMarkReview}
            />
          </div>
        </div>
      </div>

      {/* Submit Modal */}
      <SubmitModal
        isOpen={isSubmitModalOpen}
        onClose={handleCloseSubmitModal}
        onSubmit={handleSubmitExam}
        title="Submit Exam?"
        subtitle="Are you sure you want to submit your answers?"
        imageSrc={images.submit_icon}
        totalQuestions={questionsData?.length || 0}
        notAttempted={stats.notVisited + stats.notAnswered}
        attempted={stats.answered}
        markedForReview={stats.marked + stats.answeredMarked}
        cancelButtonProps={{
          title: "Cancel",
          variant: "outlined",
          color: "default",
          onClick: handleCloseSubmitModal,
        }}
        submitButtonProps={{
          title: loading ? "Submit Test" : "Submit",
          variant: "contained",
          color: "error",
          onClick: handleSubmitExam,
        }}
      />

      {submitResult && (
        <div className="exam-submit-result">
          <p>
            <strong>Submit Status:</strong> {submitResult.message}
          </p>
          <p>
            <strong>Exam ID:</strong> {submitResult.data}
          </p>
        </div>
      )}
    </div>
  );
};

export default TestScreen;
